import React from 'react';
import { Card, CssBaseline } from '@mui/material';
import styled from 'styled-components';
import SEO from '../../components/SEO';
import { Navbar } from '../Navbar/Navbar';
import { Footer } from '../Footer';
import FAQDoc from './Documentation/WatchNodDocumentation/Faq/FAQDoc';

const StyledCard = styled.div`
  background-color: #f7f7f7;
  padding: 0px;
 box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
`;

const TopMargin = styled.div`
  margin-top: 100px;
`;

const FormSide = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;

function FAQPage() {
  return (
    <>
      <SEO
        title="WatchNod FAQs | Server, API & Domain Monitoring Help"
        description="Find answers to common questions about server, API, and domain monitoring, plans, setup, and alerts to manage your infrastructure efficiently."
        keywords="WatchNod FAQs, wallet recharge help, monitoring setup, enterprise plan, WatchNod support, server monitoring help, add monitoring address, WatchNod troubleshooting"
        url="/faq"
      />


      <Navbar />
      <TopMargin />
      <CssBaseline />
      <StyledCard>
        <Card>
          <FormSide>
            <div className="container" id="contact-us">
              <FAQDoc />
            </div>
          </FormSide>
        </Card>
      </StyledCard>
      <div style={{ position: 'relative', bottom: 0, width: '100%' }}>
        <Footer />
      </div>
    </>
  );
}

export default FAQPage;
